import * as React from 'react';
import { FC } from 'react';

import { OnClick } from '@rbi-ctg/frontend';
import SanityBlockRenderer from 'components/sanity-block-renderer';
import { LoyaltyOffer } from 'state/loyalty/types';

import {
  Container,
  Content,
  ImageContainer,
  RadioButton,
  TitleText,
} from './modal-surprise-card.styled';

const ModalSurpriseCard: FC<{
  offer: LoyaltyOffer;
  checked: boolean;
  handleSelectOffer: OnClick;
}> = ({ offer, checked, handleSelectOffer }) => {
  const image = offer.localizedImage?.locale?.app;
  const offerName = offer.name?.localeRaw;

  if (!image || !offerName) {
    return null;
  }

  const selectOffer = () => {
    handleSelectOffer(offer);
  };

  return (
    <Container onClick={selectOffer}>
      <ImageContainer image={image} alt={offerName} />
      <Content>
        <TitleText>
          <SanityBlockRenderer content={offerName} />
        </TitleText>
        <RadioButton option={{}} checked={checked} onChange={selectOffer} size={1.5} />
      </Content>
    </Container>
  );
};

export default ModalSurpriseCard;
